// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo__fcd {
  height: inherit;
  width: inherit;

  padding: 0;
  margin: 0;

  svg {
    height: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ai/junie/junie-logo/junie-logo.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;;EAEd,UAAU;EACV,SAAS;;EAET;IACE,YAAY;EACd;AACF","sourcesContent":[".logo {\n  height: inherit;\n  width: inherit;\n\n  padding: 0;\n  margin: 0;\n\n  svg {\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `logo__fcd`
};
export default ___CSS_LOADER_EXPORT___;
